const parseWarrantyData = (record) => {
  const raw = record?.warrantyData;
  if (raw == null) return null;
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  if (typeof raw === 'object') {
    return raw;
  }
  return null;
};

/**
 * รายการ { mobileBrandId, mobileModelName, mobileBrandName? } จาก warrantyData.mobiles
 * หากไม่มี mobiles หรือว่าง คืน null (ให้ fallback ใช้ฟิลด์ root)
 */
export const getWarrantyMobilesList = (record) => {
  const data = parseWarrantyData(record);
  const list = data?.mobiles;
  if (!Array.isArray(list) || list.length === 0) {
    return null;
  }
  return list;
};

const brandLine = (m, index, record) => {
  if (m?.mobileBrandName) {
    return m.mobileBrandName;
  }
  if (index === 0 && record?.mobileBrandName) {
    return record.mobileBrandName;
  }
  if (m?.mobileBrandId != null) {
    return `(${m.mobileBrandId})`;
  }
  return '–';
};

const modelLine = (m) => {
  if (m?.mobileModelName != null && m.mobileModelName !== '') {
    return m.mobileModelName;
  }
  return '–';
};

/** แต่ละบรรทัดยี่ห้อ หรือ null = ใช้ record.mobileBrandName แบบเดิม */
export const getWarrantyBrandsDisplayLines = (record) => {
  const list = getWarrantyMobilesList(record);
  if (!list) {
    return null;
  }
  return list.map((m, i) => brandLine(m, i, record));
};

/** แต่ละบรรทัดรุ่น หรือ null = ใช้ record.mobileModelName แบบเดิม */
export const getWarrantyModelsDisplayLines = (record) => {
  const list = getWarrantyMobilesList(record);
  if (!list) {
    return null;
  }
  return list.map((m) => modelLine(m));
};

const MAX_WARRANTY_MOBILE_EXPORT_SLOTS = 3;

const toExportCellValue = (line) => (line == null || line === '–' ? '' : line);

export const getWarrantyBrandExportValueAt = (record, index) => {
  const lines = getWarrantyBrandsDisplayLines(record);
  if (!lines) {
    return index === 0 ? (record?.mobileBrandName ?? '') : '';
  }
  return toExportCellValue(lines[index]);
};

export const getWarrantyModelExportValueAt = (record, index) => {
  const lines = getWarrantyModelsDisplayLines(record);
  if (!lines) {
    return index === 0 ? (record?.mobileModelName ?? '') : '';
  }
  return toExportCellValue(lines[index]);
};

export const getWarrantyBrandModelExportFields = (record) => {
  const fields = {};
  for (let i = 0; i < MAX_WARRANTY_MOBILE_EXPORT_SLOTS; i += 1) {
    const n = i + 1;
    fields[`mobileBrandName${n}`] = getWarrantyBrandExportValueAt(record, i);
    fields[`mobileModelName${n}`] = getWarrantyModelExportValueAt(record, i);
  }
  return fields;
};

export const getWarrantyBrandExportValue = (record) => {
  const lines = getWarrantyBrandsDisplayLines(record);
  if (!lines) {
    return record?.mobileBrandName ?? '';
  }
  return lines.join(', ');
};

export const getWarrantyModelExportValue = (record) => {
  const lines = getWarrantyModelsDisplayLines(record);
  if (!lines) {
    return record?.mobileModelName ?? '';
  }
  return lines.join(', ');
};
